"use strict";

var _themeSections = require("@shopify/theme-sections");

var _ebooksRenderVue = _interopRequireDefault(require("../components/ebooks-render-vue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: eBooks
 * ------------------------------------------------------------------------------
 * Configured section to display a list of purchased ebooks and their download links
 *
 * @namespace ebooks
 */

/**
 * Register a single ebooks section.
 * Executes on page load as well as Theme Editor `section:load` events.
 */


(0, _themeSections.register)('ebooks', {
  onLoad: function onLoad() {
    (0, _ebooksRenderVue["default"])();
  }
});